/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { FiArrowRight } from 'react-icons/fi'

import Button from '../../components/Button'
import Header from '../../components/Header'

import { Container, Content, Line } from './styles'

const End: React.FC = () => {
  const history = useHistory()

  const handleNewParticipant = useCallback(() => {
    localStorage.removeItem('@CERES:authTerms')
    localStorage.removeItem('@CERES:erroProps')
    localStorage.removeItem('@CERES:financialRespData')
    localStorage.removeItem('@CERES:Indicado')
    localStorage.removeItem('@CERES:indicationData')
    localStorage.removeItem('@CERES:legalRespData')
    localStorage.removeItem('@CERES:participantsGroup')
    localStorage.removeItem('@CERES:PercentualValuePercent')
    localStorage.removeItem('@CERES:receiveTypeSelected')
    localStorage.removeItem('@CERES:respFinanceiro')
    localStorage.removeItem('@CERES:respLegal')
    localStorage.removeItem('@CERES:respLegalEqualFin')
    localStorage.removeItem('@CERES:TimeValueYears')
    localStorage.removeItem('@CERES:tipoContrib')
    localStorage.removeItem('@CERES:totalBalance')
    localStorage.removeItem('@CERES:totalRentability')
    localStorage.removeItem('@CERES:userAccount')
    localStorage.removeItem('@CERES:userData')
    localStorage.removeItem('@CERES:userDetails')
    history.push('/')
  }, [history])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <h3>
            <strong>Pronto</strong>, seu pedido de adesão ao Plano Família Ceres
            foi salvo com sucesso!
          </h3>
          <p>
            Confira seu e-mail. Enviamos uma mensagem com instruções de acesso à
            área restrita.
          </p>

          <Line />

          <span>Que tal realizar a adesão de mais algum familiar?</span>

          <Button type="button" color="green" onClick={handleNewParticipant}>
            Sim, eu quero!
            <div>
              <FiArrowRight />
            </div>
          </Button>
        </Content>
      </Container>
    </>
  )
}

export default End
